module.exports = __webpack_public_path__ + "img/3.d0a2eb42.jpg";